import { render, staticRenderFns } from "./clazz-list-add.vue?vue&type=template&id=1ed6173f&scoped=true&"
import script from "./clazz-list-add.vue?vue&type=script&lang=js&"
export * from "./clazz-list-add.vue?vue&type=script&lang=js&"
import style0 from "./clazz-list-add.vue?vue&type=style&index=0&id=1ed6173f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6173f",
  null
  
)

export default component.exports